import { render } from "./ClassesCard2.vue?vue&type=template&id=1ac319dd&scoped=true"
import script from "./ClassesCard2.vue?vue&type=script&lang=js"
export * from "./ClassesCard2.vue?vue&type=script&lang=js"

import "./ClassesCard2.vue?vue&type=style&index=0&id=1ac319dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac319dd"]])

export default __exports__